import { render, staticRenderFns } from "./autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&"
import script from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"
export * from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd10dcf0')) {
      api.createRecord('cd10dcf0', component.options)
    } else {
      api.reload('cd10dcf0', component.options)
    }
    module.hot.accept("./autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&", function () {
      api.rerender('cd10dcf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/autocomplete/src/autocomplete-suggestions.vue"
export default component.exports